export const model = {
  id: null,
  skill: '',
  created_at: '',
  updated_at: '',
};
